import { SectionHeader, Typography } from 'web-library';
import React from 'react';
import { useTOCStyles } from '../../../pages/helpdesk/TermsOfUse';

const UseOfDataPrivacyStatement = () => {
  const { classes } = useTOCStyles();
  return (
    <div>
      <SectionHeader title="Use of Data" />
      <ol type="a" start={4}>
        <li className={classes.paragraph}>
          <Typography variant="body1">If you provide us with personal data:</Typography>

          <ol type="i">
            <li className={classes.paragraph}>
              <Typography variant="body1">
                {`Where appropriate, we may share necessary data with other Government agencies, ` +
                  `so as to improve the discharge of public functions, and to serve you in the most efficient and effective ` +
                  `way unless such sharing is prohibited by law.`}
              </Typography>
            </li>
            <li className={classes.paragraph}>
              <Typography variant="body1">
                {`We may share your personal data with non-Government entities that have been ` +
                  `authorised to carry out specific Government services. We will NOT share your personal data with ` +
                  `other non-Government entities without your consent except where such sharing complies with the ` +
                  `law.`}
              </Typography>
            </li>
            <li className={classes.paragraph}>
              <Typography variant="body1">
                {`For your convenience, we may also display to you data you had previously supplied us ` +
                  `or other Government agencies. This will speed up the transaction and save you the trouble of ` +
                  `repeating previous submissions. Should the data be out-of-date, please supply us the latest data.`}
              </Typography>
            </li>
          </ol>
        </li>
      </ol>
    </div>
  );
};

export default UseOfDataPrivacyStatement;
